var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#414651",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M3.334 9.524c-1.235.545-2 1.304-2 2.143 0 1.657 2.984 3 6.666 3s6.667-1.343 6.667-3c0-.84-.766-1.598-2-2.143M12 5.334c0 2.709-3 4-4 6-1-2-4-3.291-4-6a4 4 0 1 1 8 0m-3.333 0a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0"
})));
export default SvgMap;